import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

import Settings from "views/Settings";

import Intro from "views/home/intro";
import About from "views/home/about";

// import Brief from "views/about/brief";
// import Features from "views/about/features";
// import WhyUs from "views/about/whyUs";

import Partners from "views/partners";
import EditPartner from "views/partners/EditPartner";
import AddPartner from "views/partners/AddPartner";
import PartnersHeading from "views/partners/Heading";
import ContactUs from "views/ContactUs";

import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";
import EditCategory from "views/categories/EditCategory";
import AddCategory from "views/categories/AddCategory";
import Categories from "views/categories";
import CategoriesHeading from "views/categories/Heading";
import Video from "views/home/video";
import AddBlog from "views/blogs/AddBlog";
import ShowBlog from "views/blogs/ShowBlog";
import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";
// import ViewEditProfile from "Profile";
// import TermsConditions from "views/termsConditions";
// import PrivacyTerms from "views/PrivacyTerms";
// import Gallery from "views/elevators";
// import AddGallery from "views/elevators/Add";
import EditGallery from "views/elevators/Edit";
import EditEquipment from "views/equipment/Edit";
// import GalleryHeading from "views/elevators/Heading";
import Testmonials from "views/testmonials";
import AddTestmonials from "views/testmonials/Add";
import EditTestmonials from "views/testmonials/Edit";
import TestmonialsHeading from "views/testmonials/Heading";
import ContactUsHeading from "views/ContactUs/Heading";
// import BannerContent from "views/blogs/banner";
import SocialTypes from "views/socialTypes";
import AddSocialTypes from "views/socialTypes/AddSocial";
import EditSocialType from "views/socialTypes/EditSocial";
import ElevatorsCategories from "views/elevators/categories";
import AddElevatorsCategory from "views/elevators/categories/AddCategory";
import EditElevatorsCategory from "views/elevators/categories/EditCategory";
import AddElevator from "views/elevators/Add";
import Elevators from "views/elevators";
import Statics from "views/home/statics";
import Collection from "views/home/collection";
import Kinds from "views/home/kinds";
import Solutions from "views/home/solutions";
import CompanySummary from "views/about/companySummary";
import DistinguishUs from "views/about/distinguishUs";
import CeoMessage from "views/about/CeoMessage";
import ContactInformation from "views/about/ContactInformation";
import Downloads from "views/Downloads";
import Branches from "views/Branches";
import EquipmentAgencies from "views/equipment/equipmentAgencies";
import ElevatorsAgencies from "views/elevators/elevatorsAgencies";
import HandicapsAgencies from "views/handicaps/handicapsAgencies";
import ProductsCategories from "views/products/categories";
import Products from "views/products";
import AddProduct from "views/products/Add";
import AddProductsCategory from "views/products/categories/AddCategory";
import EditProductsCategory from "views/products/categories/EditCategory";
import EditProduct from "views/products/Edit";
import Equipment from "views/equipment";
import AddEquipment from "views/equipment/Add";
import EquipmentCategories from "views/equipment/categories";
import AddEquipmentCategory from "views/equipment/categories/AddCategory";
import EditEquipmentCategory from "views/equipment/categories/EditCategory";
import Handicaps from "views/handicaps";
import AddHandicaps from "views/handicaps/Add";
import EditHandicaps from "views/handicaps/Edit";
import HandicapsCategories from "views/handicaps/categories";
import AddHandicapsCategory from "views/handicaps/categories/AddCategory";
import EditHandicapsCategory from "views/handicaps/categories/EditCategory";
import ProductsHeading from "views/products/Heading";
import Projects from "views/projects";
import AddProjects from "views/projects/Add";
import EditProjects from "views/projects/Edit";
import ProjectsCategories from "views/projects/categories";
import AddProjectsCategory from "views/projects/categories/AddCategory";
import EditProjectsCategory from "views/projects/categories/EditCategory";
import FooterBackground from "views/ContactUs/FooterBackground";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}
              <Route
                path="/home/intro"
                element={
                  <AuthRoute>
                    <Intro />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/about"
                element={
                  <AuthRoute>
                    <About />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/video"
                element={
                  <AuthRoute>
                    <Video />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/collection"
                element={
                  <AuthRoute>
                    <Collection />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/kinds"
                element={
                  <AuthRoute>
                    <Kinds />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/professionalSolutions"
                element={
                  <AuthRoute>
                    <Solutions />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/productsHeading"
                element={
                  <AuthRoute>
                    <ProductsHeading />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/statics"
                element={
                  <AuthRoute>
                    <Statics />
                  </AuthRoute>
                }
              />

              {/* about  */}
              <Route
                path="/aboutUs"
                element={
                  <AuthRoute>
                    <CompanySummary />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/companySummary"
                element={
                  <AuthRoute>
                    <CompanySummary />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/distinguishUs"
                element={
                  <AuthRoute>
                    <DistinguishUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/ceoMessage"
                element={
                  <AuthRoute>
                    <CeoMessage />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/contactInformation"
                element={
                  <AuthRoute>
                    <ContactInformation />
                  </AuthRoute>
                }
              />

              {/* projects */}
              <Route
                path="/categories"
                element={
                  <AuthRoute>
                    <Categories />
                  </AuthRoute>
                }
              />

              <Route
                path="/categories/add"
                element={
                  <AuthRoute>
                    <AddCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/categories/heading"
                element={
                  <AuthRoute>
                    <CategoriesHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/categories/:id"
                element={
                  <AuthRoute>
                    <EditCategory />
                  </AuthRoute>
                }
              />

              {/* elevators */}
              <Route
                path="/elevators"
                element={
                  <AuthRoute>
                    <Elevators />
                  </AuthRoute>
                }
              />
              <Route
                path="/elevators/add"
                element={
                  <AuthRoute>
                    <AddElevator />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/elevators/heading"
                element={
                  <AuthRoute>
                    <GalleryHeading />
                  </AuthRoute>
                }
              /> */}

              <Route
                path="/elevators/:id"
                element={
                  <AuthRoute>
                    <EditGallery />
                  </AuthRoute>
                }
              />

              <Route
                path="/elevators/elevatorsCategories"
                element={
                  <AuthRoute>
                    <ElevatorsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/elevators/elevatorsCategories/add"
                element={
                  <AuthRoute>
                    <AddElevatorsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/elevators/elevatorsCategories/:id"
                element={
                  <AuthRoute>
                    <EditElevatorsCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/elevators/elevatorsAgencies"
                element={
                  <AuthRoute>
                    <ElevatorsAgencies />
                  </AuthRoute>
                }
              />
              {/* equipment */}
              <Route
                path="/equipment"
                element={
                  <AuthRoute>
                    <Equipment />
                  </AuthRoute>
                }
              />
              <Route
                path="/equipment/add"
                element={
                  <AuthRoute>
                    <AddEquipment />
                  </AuthRoute>
                }
              />

              <Route
                path="/equipment/:id"
                element={
                  <AuthRoute>
                    <EditEquipment />
                  </AuthRoute>
                }
              />

              <Route
                path="/equipment/equipmentCategories"
                element={
                  <AuthRoute>
                    <EquipmentCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/equipment/equipmentCategories/add"
                element={
                  <AuthRoute>
                    <AddEquipmentCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/equipment/equipmentCategories/:id"
                element={
                  <AuthRoute>
                    <EditEquipmentCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/equipment/equipmentAgencies"
                element={
                  <AuthRoute>
                    <EquipmentAgencies />
                  </AuthRoute>
                }
              />

              {/* Handicaps */}
              <Route
                path="/handicaps"
                element={
                  <AuthRoute>
                    <Handicaps />
                  </AuthRoute>
                }
              />
              <Route
                path="/handicaps/add"
                element={
                  <AuthRoute>
                    <AddHandicaps />
                  </AuthRoute>
                }
              />

              <Route
                path="/handicaps/:id"
                element={
                  <AuthRoute>
                    <EditHandicaps />
                  </AuthRoute>
                }
              />

              <Route
                path="/handicaps/handicapsCategories"
                element={
                  <AuthRoute>
                    <HandicapsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/handicaps/handicapsCategories/add"
                element={
                  <AuthRoute>
                    <AddHandicapsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/handicaps/handicapsCategories/:id"
                element={
                  <AuthRoute>
                    <EditHandicapsCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/handicaps/handicapsAgencies"
                element={
                  <AuthRoute>
                    <HandicapsAgencies />
                  </AuthRoute>
                }
              />
              {/* Projects */}
              <Route
                path="/projects"
                element={
                  <AuthRoute>
                    <Projects />
                  </AuthRoute>
                }
              />
              <Route
                path="/projects/add"
                element={
                  <AuthRoute>
                    <AddProjects />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/:id"
                element={
                  <AuthRoute>
                    <EditProjects />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/projectsCategories"
                element={
                  <AuthRoute>
                    <ProjectsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/projects/projectsCategories/add"
                element={
                  <AuthRoute>
                    <AddProjectsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/projectsCategories/:id"
                element={
                  <AuthRoute>
                    <EditProjectsCategory />
                  </AuthRoute>
                }
              />

              {/* products */}
              <Route
                path="/products"
                element={
                  <AuthRoute>
                    <Products />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/add"
                element={
                  <AuthRoute>
                    <AddProduct />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/:id"
                element={
                  <AuthRoute>
                    <EditProduct />
                  </AuthRoute>
                }
              />

              <Route
                path="/products/productsCategories"
                element={
                  <AuthRoute>
                    <ProductsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/productsCategories/add"
                element={
                  <AuthRoute>
                    <AddProductsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/products/productsCategories/:id"
                element={
                  <AuthRoute>
                    <EditProductsCategory />
                  </AuthRoute>
                }
              />

              {/* testmonials */}
              <Route
                path="/testmonials"
                element={
                  <AuthRoute>
                    <Testmonials />
                  </AuthRoute>
                }
              />
              <Route
                path="/testmonials/add"
                element={
                  <AuthRoute>
                    <AddTestmonials />
                  </AuthRoute>
                }
              />
              <Route
                path="/testmonials/heading"
                element={
                  <AuthRoute>
                    <TestmonialsHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/testmonials/:id"
                element={
                  <AuthRoute>
                    <EditTestmonials />
                  </AuthRoute>
                }
              />

              {/* partners */}
              <Route
                path="/home/partners"
                element={
                  <AuthRoute>
                    <Partners />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/addPartner"
                element={
                  <AuthRoute>
                    <AddPartner />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/heading"
                element={
                  <AuthRoute>
                    <PartnersHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/:id"
                element={
                  <AuthRoute>
                    <EditPartner />
                  </AuthRoute>
                }
              />

              {/* <Route
                path="/pages/terms-and-conditions"
                element={
                  <AuthRoute>
                    <TermsConditions />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/pages/downloads"
                element={
                  <AuthRoute>
                    <Downloads />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/branches"
                element={
                  <AuthRoute>
                    <Branches />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/pages/privacyTerms"
                element={
                  <AuthRoute>
                    <PrivacyTerms />
                  </AuthRoute>
                }
              /> */}

              <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/show/:id"
                element={
                  <AuthRoute>
                    <ShowBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories"
                element={
                  <AuthRoute>
                    <BlogCategories />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories/addcategory"
                element={
                  <AuthRoute>
                    <AddBlogCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories/:id"
                element={
                  <AuthRoute>
                    <EditBlogCategory />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/blogs/heading"
                element={
                  <AuthRoute>
                    <Heading />
                  </AuthRoute>
                }
              /> */}

              {/* subscribers */}
              {/* <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/profile"
                element={
                  <AuthRoute>
                    <ViewEditProfile />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/heading"
                element={
                  <AuthRoute>
                    <ContactUsHeading />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/footerBackground"
                element={
                  <AuthRoute>
                    <FooterBackground />
                  </AuthRoute>
                }
              />

              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />

              {/* socials */}
              <Route
                path="/socials"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              />
              {/* socialTypes */}
              <Route
                path="/socialTypes"
                element={
                  <AuthRoute>
                    <SocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/:id"
                element={
                  <AuthRoute>
                    <EditSocialType />
                  </AuthRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
